// src/services/pushNotificationService.ts
import { logger } from '../utils/logger';

 // Updated navigation to use proper paths and fallbacks



 import { PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';

 import { supabase } from './supabase';

 import { Capacitor } from '@capacitor/core';



 export const pushNotificationService = {

   async register() {

     // Only run on mobile platforms

     if (!Capacitor.isNativePlatform()) {

       logger.log('Push notifications only work on mobile platforms');

       return;

     }



     try {

       // Request permission

       let permStatus = await PushNotifications.checkPermissions();



       if (permStatus.receive === 'prompt') {

         permStatus = await PushNotifications.requestPermissions();

       }



       if (permStatus.receive !== 'granted') {

         logger.log('Push notification permission denied');

         return;

       }



       // Register with FCM/APNs

       await PushNotifications.register();



       // Listen for registration success

       await PushNotifications.addListener('registration', async (token: Token) => {

         logger.log('Push registration success, token:', token.value);

         await this.saveToken(token.value);

       });



       // Handle registration errors

       await PushNotifications.addListener('registrationError', (error: any) => {

         logger.error('Error on registration:', error);

       });



       // Handle notification received while app is in foreground

       await PushNotifications.addListener('pushNotificationReceived', (notification) => {

         logger.log('Push notification received:', notification);

         // You can show a local notification or update UI here

       });



       // Handle notification tapped

       await PushNotifications.addListener('pushNotificationActionPerformed',

         (notification: ActionPerformed) => {

           logger.log('Push notification tapped:', notification);

           this.handleNotificationTap(notification);

         }

       );

     } catch (error) {

       logger.error('Error registering for push notifications:', error);

     }

   },



   async saveToken(token: string) {

     try {

       const { data: { user } } = await supabase.auth.getUser();

       if (!user) return;



       const platform = Capacitor.getPlatform();

       const tokenField = platform === 'ios' ? 'apns_token' : 'fcm_token';



       const { error } = await supabase

         .from('profiles')

         .update({ [tokenField]: token })

         .eq('id', user.id);



       if (error) {

         logger.error('Error saving push token:', error);

       } else {

         logger.log('âœ… Push token saved successfully');

       }

     } catch (error) {

       logger.error('Error in saveToken:', error);

     }

   },



   handleNotificationTap(notification: ActionPerformed) {

     const data = notification.notification.data;

     logger.log('ðŸ“± Handling notification tap:', data);



     // Small delay to ensure app is fully loaded

     setTimeout(() => {

       try {

         // Navigate based on notification type

         switch (data.type) {

           case 'new_message':

             // Navigate to chat with this match

             logger.log('Opening direct message chat:', data.matchId);

             window.location.href = `/tabs/chats?openChat=${data.matchId}`;

             break;



           case 'new_group_message':

             // Navigate to group chat

             logger.log('Opening group chat:', data.groupId);

             window.location.href = `/tabs/chats?openGroup=${data.groupId}`;

             break;



           case 'new_connection_request':

             // Navigate to requests tab

             logger.log('Opening connection requests');

             window.location.href = '/tabs/chats?tab=requests';

             break;



           case 'connection_accepted':

             // Navigate to connections

             logger.log('Opening connections');

             window.location.href = '/tabs/chats';

             break;



           case 'added_to_group':

             // Navigate to the group they were added to

             logger.log('Opening group after being added:', data.groupId);

             window.location.href = `/tabs/chats?openGroup=${data.groupId}`;

             break;



           case 'session_invite':
            // falls through
           case 'session_rsvp_accepted':

             // Navigate to session detail

             logger.log('Opening session:', data.sessionId);

             // Use tabs path for better navigation

             window.location.href = `/tabs/sessions/${data.sessionId}`;

             break;



           case 'new_report':

             // Navigate to admin page

             logger.log('Opening admin page for new report:', data.reportId);

             window.location.href = '/admin';

             break;



           default:

             // Default to chats tab (connections)

             logger.log('Opening default chats tab');

             window.location.href = '/tabs/chats';

         }

       } catch (error) {

         logger.error('Error handling notification tap:', error);

         // Fallback to chats tab if navigation fails

         window.location.href = '/tabs/chats';

       }

     }, 300);

   },



   async checkPermissions() {

     if (!Capacitor.isNativePlatform()) {

       return { receive: 'denied' };

     }



     try {

       return await PushNotifications.checkPermissions();

     } catch (error) {

       logger.error('Error checking permissions:', error);

       return { receive: 'denied' };

     }

   }

 };